import { render, staticRenderFns } from "./importAmendBom.vue?vue&type=template&id=2cd091f6&scoped=true&"
import script from "./importAmendBom.vue?vue&type=script&lang=js&"
export * from "./importAmendBom.vue?vue&type=script&lang=js&"
import style0 from "./importAmendBom.vue?vue&type=style&index=0&id=2cd091f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd091f6",
  null
  
)

export default component.exports